var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.765 291.765",
    style: {
      enableBackground: "new 0 0 291.765 291.765"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A66333"
    },
    d: "M273.529,118.529V63.824c0-10.066-8.169-18.235-18.235-18.235H18.235 C8.169,45.588,0,53.758,0,63.824v155c0,10.066,8.169,18.235,18.235,18.235h237.059c10.066,0,18.235-8.169,18.235-18.235v-54.706 c10.066,0,18.235-8.169,18.235-18.235v-9.118C291.766,126.699,283.604,118.529,273.529,118.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E7E7"
    },
    d: "M45.588,0h182.353c10.066,0,18.235,8.169,18.235,18.244v127.638 c0,10.075-8.169,18.235-18.235,18.235H45.588c-10.066,0-18.235-8.169-18.235-18.235V18.244C27.353,8.169,35.522,0,45.588,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#868686"
    },
    d: "M84.466,45.78c0,0,11.06-0.191,21.509-0.191c10.458,0,12.309,17.579,12.309,17.579 s0.191,18.39,0.191,22.922c0,4.541-8.999,13.54-8.999,13.54v9.236l27.362,10.941v16.959H54.651l0.091-17.314l27.389-10.494v-9.045 c0,0-9.099-8.142-9.099-13.822V63.167C73.032,63.167,73.816,45.78,84.466,45.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 145.882,
    y: 82.059,
    style: {
      fill: "#B7BBBD"
    },
    width: 63.824,
    height: 18.235
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.882,
    y: 45.588,
    style: {
      fill: "#B7BBBD"
    },
    width: 63.824,
    height: 18.244
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7BBBD"
    },
    d: "M227.941,0H45.588C35.522,0,27.353,8.169,27.353,18.244v9.109h218.824v-9.109 C246.176,8.169,238.016,0,227.941,0z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B459"
    },
    d: "M18.235,72.95l200.588,27.344c10.066,0,18.235,8.169,18.235,18.235v155 c0,10.066-8.169,18.235-18.235,18.235L18.235,264.412C8.169,264.412,0,256.242,0,246.176V54.706C0,64.845,8.169,72.95,18.235,72.95 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E7E7"
    },
    d: "M196.029,164.118c7.549,0,13.676,6.127,13.676,13.676s-6.127,13.676-13.676,13.676 s-13.676-6.118-13.676-13.676S188.48,164.118,196.029,164.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D07C40"
    },
    d: "M18.235,264.412l200.588,27.353c10.066,0,18.235-8.169,18.235-18.235v-36.471L18.235,209.706 C8.169,209.706,0,201.6,0,191.471v54.706C0,256.251,8.169,264.412,18.235,264.412z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D07C40"
    },
    d: "M246.176,155c0,0,45.588-9.51,45.588-18.235v27.353c0,0-8.169,18.235-18.235,18.235l-27.353,9.118 c-10.075,0-18.235-8.169-18.235-18.235C227.941,163.169,236.111,155,246.176,155z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletSvg);
export default __webpack_public_path__ + "static/media/wallet-svg.c3e62d6478e42568a26ea747e8fc0e70.svg";
export { ForwardRef as ReactComponent };